export const cocoSearchMarkerSelector = ({cocoSearchMarker}) => cocoSearchMarker